import { transitionMotorInsuranceQuoteForm } from '../../../actions/naMotorInsurance/quote';
import { getQuoteForm } from '../../../selectors/naMotorInsurance/quote';

import { FIELD_STATUS } from '../../../reducers/status';

export const quoteFormRules = (store, next, action) => {
    const result = next(action);
    const quoteForm = getQuoteForm(store.getState());
    const quoteFormValid = validateQuoteForm(quoteForm);
    const formAction = quoteFormValid
        ? transitionMotorInsuranceQuoteForm.formValid()
        : transitionMotorInsuranceQuoteForm.formInvalid();
    store.dispatch(formAction);
    return result;
};

const validateQuoteForm = (formFields) => {
    const required =
        formFields.carMake.status === FIELD_STATUS.VALID &&
        formFields.carModel.status === FIELD_STATUS.VALID &&
        formFields.yearOfManufacture.status === FIELD_STATUS.VALID &&
        formFields.valuation.status === FIELD_STATUS.VALID &&
        formFields.coverStartDate.status === FIELD_STATUS.VALID &&
        formFields.hasAlarm.status === FIELD_STATUS.VALID &&
        formFields.trackingSystem.status === FIELD_STATUS.VALID;

    return required;
};
